import React from 'react'
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import store from "./store";
import './index.css'
import 'normalize.css'
import App from './app'

import { GlobalStyles } from './assets/styles'

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
     <Provider store={store}>
      <GlobalStyles />
      <App />
     </Provider>

)
